<template>
  <!--  <figure :style="styles" :class="{ 'logo': true, 'logo--inverse': inverse }"></figure> -->
  <a href="/" class="logo">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="height"
      :viewBox="viewBox"
      aria-label="I.AM.GIA brand logo"
      role="presentation"
    >
      <title lang="en">{{ iconName }}</title>
      <g :fill="iconColor">
        <slot></slot>
      </g>
    </svg>
  </a>
</template>

<script>
export default {
  props: {
    iconName: { type: String, default: 'box' },
    viewBox: { type: String, default: '0 0 18 18' },
    width: { type: [Number, String], default: '18px' },
    height: { type: [Number, String], default: '18px' },
    iconColor: { type: String, default: 'currentColor' },
  },
}
</script>
